import Image from "next/image";
import React from "react";

const OneConnectLoginContent = () => {
  return (
    <div className="fixed inset-0 w-screen h-screen">
      <div className="relative w-full h-full">
        <Image
          src="/images/OneConnect-BackgroundImage.webp"
          alt="login bg"
          layout="fill"
          priority
          className="object-cover z-0"
        />
      </div>

      <div className="absolute top-4 left-4 z-20">
        <Image
          src="/images/OneWorkLogo.svg"
          width={140}
          height={68}
          alt="logo"
          priority
        />
      </div>

      <div className="md:flex items-center justify-center md:absolute w-full h-[15vh] z-10 transform md:top-[42%] md:left-[32%] md:-translate-x-1/2 md:-translate-y-1/2">
        <p className="text-[#82D8A4] font-inter font-semibold text-[40px] mt-12 leading-[120%] tracking-normal">
          <span className="block">Continuous</span>
          <span className="block">Engagement for a</span>
          <span className="block">Connected Workforce</span>
        </p>
      </div>

      <div className="absolute bottom-0 left-0 z-20">
        <Image
          src="/images/CLogo1.webp"
          width={420}
          height={420}
          alt="C logo"
          quality={80}
        />
      </div>

      <div className="absolute top-0 right-0 z-20">
        <Image
          src="/images/LogoThree1.webp"
          width={560}
          height={560}
          alt="Logo Three"
          quality={80}
        />
      </div>
    </div>
  );
};

export default OneConnectLoginContent;
